export const environment = {
  production: true,
  apiBaseUrl: '__API_BASE_URL__',
  getAddressIoDToken: 'PKjsAEkr0U-ZsBhuqXad9w6498',
  auth: {
    url: '__AUTH_URL__',
    realm: '__REALM__',
    clientId: '__CLIENT_ID__',
  },
  landingRoute: 'case',
  featureFlags: [
    { feature: 'cases', enabled: true },
    { feature: 'individuals', enabled: true },
    { feature: 'users', enabled: true },
  ],
  faro: {
    url: '__GRAFANA_COLLECTOR_URL__',
    appName: '__GRAFANA_APP_NAME__',
    environment: '__GRAFANA_ENVIRONMENT__',
  },
};
